/**
 * Auflistung der Formulareingaben zu einem Vorgang (über Vorlage)
 */
import * as React from 'react';
import { IVorgangFormularKategorie, IVorgangFormulardaten, IMeta } from '../../models/ApiTypes';
import { Form, FormControlProps, Button } from 'react-bootstrap';
import VorgangFormularKategorie from '../vorlagen/VorgangFormularKategorie';
import { bind } from '../../utils/decorators';
import Callout from '../site/Callout';
import { ApiStore } from '../../stores/ApiStore';
import { inject } from '../../utils/decorators';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { VorgangStore } from '../../stores/VorgangStore';
const serialize = require('form-serialize');


export interface IVorgangFormularEingabenProps {
  vorgangId: string;
  formular_kategorien: IVorgangFormularKategorie[];
  formulardaten?: IVorgangFormulardaten[];
  editable?: boolean;
  handleDocumentRefresh: () => void;
  handleFormDataSubmitted: () => void;
}

export interface IVorgangFormularKategorieState {
  kategorien: VorgangFormularKategorie[];
}

@observer
export default class VorgangFormularEingaben extends React.Component<IVorgangFormularEingabenProps, IVorgangFormularKategorieState> {

  @inject(ApiStore) apiStore: ApiStore;
  @inject(VorgangStore) vorgangStore: VorgangStore;

  @observable requestInProgress: boolean = false;
  @observable validationstate: 'success' | 'warning' | 'error' | undefined = 'error';
  @observable zeitpunktGespeichert: string | undefined = undefined;

  constructor(props: IVorgangFormularEingabenProps) {
    super(props);
    this.state = { kategorien: new Array<VorgangFormularKategorie>() };
    if (this.props.formular_kategorien) {
      this.props.formular_kategorien.forEach(item => {
        const kategorie = new VorgangFormularKategorie({...item});
        this.state.kategorien.push(kategorie);
      });
    }
  }

  componentDidMount() {
    this.setValidationState('success');
    for (let kategorie of this.state.kategorien) {
      if (kategorie.validationstate === 'error') {
        this.setValidationState('error');
      }
    }
  }

  @action private setValidationState(state: 'success' | 'warning' | 'error' | undefined = 'error') {
    this.validationstate = state;
  }

  @action private setZeitpunktGespeichert(value: string | undefined) {
    this.zeitpunktGespeichert = value;
  }

  @bind async handleFormularEingabenSubmit(event: React.FormEvent<FormControlProps>) {
    event.preventDefault();
    this.setRequesInProgress(true);
    const serialized: string = serialize(event.currentTarget, { hash: true });
    const response = await this.apiStore.vorgangFormularEingaben(this.props.vorgangId, serialized);
    if (response.ok) {
      if (response.json.date) {
        this.setZeitpunktGespeichert(response.json.date);
      }
      this.props.handleDocumentRefresh();
    }
    this.props.handleFormDataSubmitted();
    this.setRequesInProgress(false);
  }

  @bind @action setRequesInProgress(value: boolean) {
    this.requestInProgress = value;
  }

  @action handleValidationStateChange = (e: VorgangFormularKategorie) => {
    // Validierungsstatus in State übernehmen
    if (this.state.kategorien) {
      for (let kategorie of this.state.kategorien) {
        if (kategorie.props.kategorieguid === e.props.kategorieguid) {
          kategorie.validationstate = e.validationstate;
        }
      }
    }

    // Validierung über alle Kategorien des Formulars
    this.validationstate = 'success';
    for (let kategorie of this.state.kategorien) {
      if (kategorie.validationstate === 'error') {
        this.validationstate = 'error';
        break;
      }
    }
  }

  public render() {
    const { formular_kategorien, formulardaten, editable } = this.props;
    const { vorgang } = this.vorgangStore;

    if (this.zeitpunktGespeichert === undefined) {
      const metaZeitpunktGespeichert: IMeta | undefined = vorgang && vorgang.meta && vorgang.meta.find(meta => meta.bezeichnung === 'formulardaten_gespeichert');
      if (metaZeitpunktGespeichert) {
        this.setZeitpunktGespeichert(metaZeitpunktGespeichert.zeitpunkt);
      }
    }

    const formularKategorien = formular_kategorien.map(element => (
      <VorgangFormularKategorie
        key={element.kategorieguid}
        editable={editable}
        formulardaten={formulardaten}
        onHandleValidationStateChange={this.handleValidationStateChange}
        vorgangId={vorgang && vorgang.vorgangguid}
        {...element}/>
      )
    );

    return (
      <Form horizontal={true} onSubmit={this.handleFormularEingabenSubmit}>
        {formularKategorien}
        {this.zeitpunktGespeichert &&
          <Callout bsStyle="default">
            <p>Eingabedaten zuletzt gespeichert am {this.zeitpunktGespeichert}</p>
          </Callout>
        }
        {editable &&
          <Callout bsStyle="success">
            <p>Speichert die bisher eingegebenen Daten im aktuellen Vorgang. Bereits gespeicherte Daten können jederzeit, bis zum Abschluß des Vorgangs, ergänzt und korrigiert werden.</p>
            <div className="text-right">
              <Button bsStyle="success" type="submit" disabled={this.requestInProgress}>Speichern</Button>
            </div>
          </Callout>
        }
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorgaenge/VorgangFormularEingaben.tsx